module.exports = __webpack_public_path__ + "img/family-1.1e4a02a2.jpg";